import PropTypes from 'prop-types';
import { PartnerPhoto } from '../partner-photo';
import { ChosenPartnerAccordion } from './chosen-partner-accordion';
import styles from './ChosenPartner.scss';

export const ChosenPartner = ({
  partner = {
    id: null,
    photoUrl: undefined,
    name: undefined,
  },
  partners,
  selectPartner,
  selectedShopId,
  partnerTitle,
  partnerPrefix,
  selectablePartnersTitle = null,
  defaultPartnerText = null,
  isEditMode = false,
  hidePartnerPrefix = false,
  hidePartnerNameUnderline = false,
  hidePartnerDescription = false,
}) => (
  <div id="chosen-partner" className={styles.ChosenPartner} data-testid="ChosenPartner">
    <div className={styles.ChosenPartner_line}>
      {partner.id ? (
        <div className={styles.Holder}>
          <p className={styles.ChosenPartner_targetLabel}>Showing dates for: &nbsp;</p>
          <div className={styles.ChosenPartner_photoWrapper}>
            <PartnerPhoto partner={partner} />
          </div>
          <div className={styles.ChosenPartner_col}>
            <h3
              className={
                hidePartnerNameUnderline ? styles.PartnerName_without_underline : styles.PartnerName
              }
              data-testid="ChosenPartnerName"
            >
              {partner.name}
            </h3>
            <p className={styles.Position}>
              {!hidePartnerPrefix && partnerPrefix}
              {partnerTitle}
            </p>
          </div>
        </div>
      ) : (
        <div className={styles.ChosenPartner_all}>
          <p className={styles.ChosenPartner_targetLabel}>Showing dates for&nbsp;</p>
          <span className={styles.AllPartnersText}>
            <p>All</p>
            &nbsp;
            <p>{partnerTitle}s</p>
          </span>
        </div>
      )}
    </div>
    <ChosenPartnerAccordion
      partners={partners}
      selectedPartner={partner}
      selectPartner={selectPartner}
      selectedShopId={selectedShopId}
      partnerTitle={partnerTitle}
      partnerPrefix={partnerPrefix}
      selectablePartnersTitle={selectablePartnersTitle}
      defaultPartnerText={defaultPartnerText}
      isEditMode={isEditMode}
      hidePartnerPrefix={hidePartnerPrefix}
      hidePartnerNameUnderline={hidePartnerNameUnderline}
      hidePartnerDescription={hidePartnerDescription}
    />
  </div>
);

ChosenPartner.propTypes = {
  partner: PropTypes.shape({
    id: PropTypes.string,
    photoUrl: PropTypes.string,
    name: PropTypes.string,
  }),
  partners: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  selectedShopId: PropTypes.string.isRequired,
  selectPartner: PropTypes.func.isRequired,
  partnerTitle: PropTypes.string.isRequired,
  partnerPrefix: PropTypes.string,
  selectablePartnersTitle: PropTypes.string,
  defaultPartnerText: PropTypes.string,
  isEditMode: PropTypes.bool,
  hidePartnerPrefix: PropTypes.bool,
  hidePartnerNameUnderline: PropTypes.bool,
  hidePartnerDescription: PropTypes.bool,
};
